document.addEventListener("DOMContentLoaded", () => {
  const chatPopup = document.querySelector(".chat-popup");
  const trigger = document.querySelector(".chat-popup__trigger");
  if (!chatPopup || !trigger)
    return;
  trigger.addEventListener("click", () => {
    chatPopup.classList.toggle("is-open");
  });
  document.addEventListener("click", (e) => {
    if (!chatPopup.contains(e.target)) {
      chatPopup.classList.remove("is-open");
    }
  });
});
